import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../Order.css';
import banner from '../../images/banners/collect.jpg'
import { Helmet } from 'react-helmet';
import Order_detail from './OrderHeavy_details2';
import OrderFunctionStore from '../../store/OrderFunctionStore';
import BACKEND_URL from '../../api';
import loading from '../../images/spin.gif'

const OrderHeavy_details = () => {
    const inputs = JSON.parse(sessionStorage.getItem('quoteheavyinput[]'))
    let userid = sessionStorage.getItem('userid');
    if (userid == null) userid = 0;
    const navigate = useNavigate();

    const { setParcelDetailOption, setParcelDetailFirstOption, parcelDetailSecondOption, setParcelDetailSecondOption } = OrderFunctionStore();
    const [collectionDetailList, setCollectionDetailList] = useState(new Array(inputs.length).fill({
        name: '',
        email: '',
        phonecode: '',
        phone: '',
        address: '',
        city: '',
        country: '',
        zip_code: ''
    }));
    const [deliveryDetailList, setDeliveryDetailList] = useState(new Array(inputs.length).fill({
        name: '',
        email: '',
        phonecode: '',
        phone: '',
        address: '',
        city: '',
        country: '',
        zip_code: ''
    }));
    const [parcelInfoList, setParcelInfoList] = useState(new Array(inputs.length).fill({
        parceldetails: {
            description: [''],
            parcel_value: [''],
            promocode: [''],
            insurance: ["No"],
            comments: [''],
            image: ['']
        }
    }))
    const [parcelDetailsCount, setParcelDetailCount] = useState([]);
    const [showload, setshowload] = useState(false)
    const [wallet, setwallet] = useState()
    const [ordertypes, setordertypes] = useState()
    const [paymentmethod, setpaymentmethod] = useState('Online')
    const [finalprice, setfinalprice] = useState()
    const [insuff, setinsuff] = useState(false)
    const [batch_id, setbatch_id] = useState()
    const [selectedparcels, setselectedparcels] = useState([])
    const [parcelDetailOptionError, setParcelDetailOptionError] = useState([])

    useEffect(() => {
        const inputsArray = JSON.parse(sessionStorage.getItem('quoteheavyinput[]'))
        const temp = new Array(inputsArray.length).fill(true);
        setParcelDetailOptionError(temp);

        setParcelDetailOption(false);
        setParcelDetailFirstOption(false);
        setParcelDetailSecondOption(false)
    }, []);

    useEffect(() => {
        if (parcelDetailSecondOption === true && !parcelDetailOptionError.includes(true)) {
            let userid = sessionStorage.getItem('userid')
            if (userid == null) userid = 0;

            axios({
                method: "post",
                url: `${BACKEND_URL}/bulkHeavyUpload`,
                data: {
                    userid: userid, collectionDetailList: collectionDetailList, deliveryDetailList: deliveryDetailList,
                    parcelInfoList: parcelInfoList, inputs: inputs, ordertypes: ordertypes
                }
            })
                .then((res) => {
                    console.log("bulkHeavyUpload-------", res.data, res.data.response_arr)

                    let total = 0;
                    res.data.response_arr.map((item, index) => {
                        total += Number(item['rate'])
                        // Assuming 'item' is defined and contains an 'orderid'
                        setselectedparcels(prevSelectedParcels => [...prevSelectedParcels, item['orderid']]);
                    })
                    setfinalprice(total.toFixed(2))
                    setParcelDetailCount(res.data.response_arr)
                    setbatch_id(res.data.batch_id)
                })
                .catch((err) => console.log(err))
                .finally(() => {                    
                    window.scrollTo(0, 0);
                })
        }
    }, [parcelDetailSecondOption, parcelDetailOptionError])

    const [paymodal, setPaymodal] = useState(false);
    const [paynow, setPaynow] = useState(false);
    const [balshow, setBalshow] = useState(false);
    const [ballow, setBallow] = useState(false);

    const setModalIsOpenToTrue33 = (orderid) => {
        console.log("batchId--------", orderid)
        setPaymodal(!paymodal);
        setPaynow(false);
        setBalshow(false);
        setBallow(false);
    }

    async function invoiceUpload(orderid, i) {
        const data = new FormData();
        const imagecount = parcelInfoList[i].parceldetails.image.length;

        for (let k = 0; k < imagecount; k++) {
            data.append("invoice", parcelInfoList[i].parceldetails.image[k]);
        }

        data.append("orderid", orderid);

        const url = `${BACKEND_URL}/invoiceUpload`;

        try {
            const res = await axios.post(url, data);
            console.log("invoiceUpload----------", res.data);

            if (res.data == 0) {
                alert("invoice file failed to upload");
            }
        } catch (error) {
            alert(error);
            console.log(error);
        }
    }

    const pay_batchuplod = () => {
        const API_PATH2 = `${BACKEND_URL}/createBatchAwb`;
        setshowload(true)

        const uniqueParcels = [...new Set(selectedparcels)];

        if (paymentmethod == "COC" || paymentmethod == "COD" || paymentmethod == "PBW") {

            axios({
                method: "post",
                url: `${API_PATH2}`,
                data: { userid: userid, paymentmethod: paymentmethod, selectedparcels: uniqueParcels, batch_id: batch_id, finalprice: finalprice, ordertype: ordertypes }
            })
                .then(async (res) => {
                    console.log('createBatchAwb response:--------- ', res.data)

                    for (const [index, item] of res.data.entries()) {
                        await invoiceUpload(item['orderno'], index);
                    }
                    // ,awbcontent:res.data.awbresult,awbcount:res.data.awbresult.length
                    if (ordertypes == 'domestic') {
                        navigate('/bulk-domestic-awb-label', { state: { userid: userid, paymentmethod: paymentmethod, selectedparcels: selectedparcels, batch_id: batch_id, finalprice: finalprice } })

                    } else {
                        navigate('/bulk-awb-label', { state: { userid: userid, paymentmethod: paymentmethod, selectedparcels: selectedparcels, batch_id: batch_id, finalprice: finalprice } })
                    }

                })
                .catch((err) => console.log(err))
                .finally(() => {
                    setshowload(false)
                })
        } else {

            const API_payment = `${BACKEND_URL}/generateBulkPayment`;
            axios({
                method: 'post',
                url: `${API_payment}`,
                data: { userid: userid, finalprice: finalprice, batch_id: batch_id, selectedparcels: uniqueParcels, ordertypes: ordertypes }
            })
                .then(async (res) => {
                    console.log("generate_bulk_payment: -----------", res.data)

                    for (const [index, item] of res.data.orderIds.entries()) {
                        await invoiceUpload(item, index);
                    }
                    
                    navigate('/checkout', { state: { orderno: batch_id, payment_page: res.data.data } })

                })
                .catch((err) => console.log(err))
                .finally(() => {
                    setshowload(false)
                })
        }
    }

    const alterpaymethod = (val) => {
        setPaynow(false);
        setBalshow(false);
        setBallow(false);
        if (val == 'COC' || val == 'COD') {
            setPaynow(true);
            if (paymentmethod != val) {
                setpaymentmethod(val)
                console.log(parseFloat(finalprice))
                setfinalprice((parseFloat(finalprice) + 10.00).toFixed(2))
            }

        } else if (val == 'PBW') {
            setBalshow(true);
            if (paymentmethod != val) {
                if (paymentmethod == 'COD' || paymentmethod == 'COC') {
                    setfinalprice((parseFloat(finalprice) - 10.00).toFixed(2))
                }

                const API_PATH2 = `${BACKEND_URL}/getWallet`;

                axios({
                    method: "post",
                    url: `${API_PATH2}`,
                    data: { userid: userid }
                })
                    .then((res) => {
                        console.log("getWallet-----", res.data)
                        setwallet(res.data.wallet)
                        if (Number(finalprice) > Number(res.data.wallet)) {
                            setinsuff(true)
                            setBallow(true);
                        }
                        else {
                            setPaynow(true);
                        }
                        setpaymentmethod(val)
                    })
                    .catch((err) => console.log(err))
            }
        } else {
            setPaynow(true);
            if (finalprice != val) {
                if (paymentmethod == 'COD' || paymentmethod == 'COC') {
                    setfinalprice((parseFloat(finalprice) - 10.00).toFixed(2))
                }
                setpaymentmethod(val)

            }
        }

    }

    return (
        <div className="order">
            <Helmet>
                <title>Shypv | Order Detail</title>
            </Helmet>
            <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 your_business text-center">
                            <div className="business_content">
                                <h1 className="mainhead">ORDER DETAIL</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div>
                {(inputs.length > 0 && parcelDetailOptionError.length > 0) ? ( // Check if inputs has elements
                    inputs.map((input, index) => (
                        <>
                            <Order_detail
                                key={index}
                                number={index}
                                inputs={input}
                                totalNumber={inputs.length}
                                collectionDetails={collectionDetailList[index]}
                                deliveryDetails={deliveryDetailList[index]}
                                parcelDetailOptionError={parcelDetailOptionError}
                                setcollectionDetails={(value) => {
                                    setCollectionDetailList(prev => {
                                        const updatedCollectionDetails = [...prev];
                                        updatedCollectionDetails[index] = value;
                                        return updatedCollectionDetails;
                                    });
                                }}
                                setParcelDetailOptionError={(value) => {
                                    setParcelDetailOptionError(prev => {
                                        const updatedCollectionDetails = [...prev];
                                        updatedCollectionDetails[index] = value;
                                        return updatedCollectionDetails;
                                    });
                                }}
                                setdeliveryDetails={(value) => {
                                    setDeliveryDetailList(prev => {
                                        const updatedDeliveryDetails = [...prev];
                                        updatedDeliveryDetails[index] = value;
                                        return updatedDeliveryDetails;
                                    });
                                }}
                                parcel_info={parcelInfoList[index]}
                                setparcel_info={(value) => {
                                    setParcelInfoList(prev => {
                                        const updatedParcelInfo = [...prev];
                                        updatedParcelInfo[index] = value;
                                        return updatedParcelInfo;
                                    });
                                }}
                            />
                            {
                                !parcelDetailOptionError.includes(true) && index == 0 && parcelDetailsCount.length > 0 && (
                                    <div className="order">
                                        <div className="parsel_container pages_content1" style={(index !== 0) ? { paddingTop: "0px" } : {}}>
                                            <div className="container" style={{ marginTop: "0px" }}>
                                                <div className="row" style={{ marginTop: "0px" }}>
                                                    <form method="post" id="parcel_details" name="parcel_details" encType="multipart/form-data" style={{ backgroundColor: "white" }}>
                                                        <div className="add_more_parcels" style={{ margin: "5% 5% 5% 5%" }}>
                                                            <div className="content-title m-x-auto">
                                                                <h6><b>My Parcels</b></h6>
                                                            </div>

                                                            {/* Payment Modal */}
                                                            {paymodal && (
                                                                <div className="rcmodal">
                                                                    <div onClick={setModalIsOpenToTrue33} className="rcoverlay"></div>
                                                                    <div className="rcmodal-content payment">
                                                                        {/* <h5>Choose Payment Option</h5> */}
                                                                        <h4 style={{ fontWeight: '600' }}>- Choose Payment Option -</h4>

                                                                        <p style={{ height: "15px" }}></p>

                                                                        <div className="row">
                                                                            <p className='ptotal'>Total Amount:{finalprice}</p>
                                                                            <p style={{ height: "15px" }}></p>
                                                                            <div className="col-md-4"><input type="radio" name="pay_method" value="online" onClick={() => alterpaymethod('Online')} /> Card Payment</div>
                                                                            <div className="col-md-4"><input type="radio" name="pay_method" value="coc" onClick={() => alterpaymethod('COC')} /> Cash On Shipment</div>
                                                                            {ordertypes && ordertypes == 'export' ? (
                                                                                <div className="col-md-4"><input type="radio" name="pay_method" value="coc" onClick={() => alterpaymethod('COC')} /> Cash On Collection</div>

                                                                            ) : ordertypes == 'import' ? (
                                                                                <div className="col-md-4"><input type="radio" name="pay_method" value="coc" onClick={() => alterpaymethod('COD')} /> Cash On Delivery</div>

                                                                            ) : null}

                                                                            {
                                                                                inputs[0].user != null && <div className="col-md-4"><input type="radio" name="pay_method" value="pbw" onClick={() => alterpaymethod('PBW')} /> Pay By Wallet</div>
                                                                            }
                                                                        </div>

                                                                        <p style={{ height: "15px" }}></p>

                                                                        {balshow && (
                                                                            <>
                                                                                <ul className="balance">
                                                                                    <li>My Balance</li>
                                                                                    <li>AED {wallet}</li>
                                                                                </ul>
                                                                                {ballow && (
                                                                                    <div id="less_wallet" style={{ textAlign: 'center', border: '1px solid red', margin: '0 auto', width: '310px' }}>
                                                                                        <p style={{ marginBottom: '6px' }}>Insufficient balance</p>
                                                                                        <Link to="/my-account/my-wallet" style={{ marginBottom: '6px' }}>Add Wallet</Link>
                                                                                    </div>
                                                                                )}
                                                                            </>

                                                                        )}

                                                                        {paynow && (

                                                                            <div className="row bulkpaybtn" >
                                                                                <p style={{ height: "15px" }}></p>
                                                                                <button type="button" className="btn-rmodal" onClick={pay_batchuplod} >PAY NOW</button>
                                                                            </div>
                                                                        )}

                                                                        {showload ? (
                                                                            <p style={{ textAlign: "center", marginTop: "2%" }}><img src={loading} style={{ width: "5%" }} /></p>
                                                                        ) : null}
                                                                        <div className="close-rcmodal" onClick={setModalIsOpenToTrue33}><strong></strong>x</div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {/* End Payment Modal */}

                                                            <table className="table-custom">
                                                                <thead className="table-header-row">
                                                                    <tr>
                                                                        <th>REFERENCE</th>
                                                                        <th>SEND FROM</th>
                                                                        <th>SEND TO</th>
                                                                        <th>STATUS</th>
                                                                        <th>WEIGHT</th>
                                                                        <th>PRICE</th>
                                                                        <th></th>
                                                                        {/* <th scope="col" colSpan='3'>QUICK SOLUTIONS</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="table-body">

                                                                    {
                                                                        parcelDetailsCount.map((e, i) => <>{
                                                                            parcelDetailsCount && parcelDetailsCount[i] != '' ? (

                                                                                <tr key={i} className={`table-row ${i % 2 === 1 ? 'odd' : 'even'}`}>
                                                                                    <td className="table-cell">{parcelDetailsCount[i]['orderid']}</td>
                                                                                    <td className="table-cell">{parcelDetailsCount[i]['shipper_country']}</td>
                                                                                    <td className="table-cell">{parcelDetailsCount[i]['consignee_country']}</td>
                                                                                    <td className="table-cell">PENDING</td>
                                                                                    <td className="table-cell">{parcelDetailsCount[i]['final_weight']}</td>
                                                                                    <td className="table-cell">{parcelDetailsCount[i]['rate']}</td>
                                                                                    <td />
                                                                                </tr>
                                                                            ) : null

                                                                        }</>)
                                                                    }


                                                                    <tr className='table-row'>
                                                                        <td className="table-cell"><b>Total:</b></td>
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td className="table-cell"><span>AED {finalprice}</span></td>
                                                                        <td className="table-cell bulkpay" onClick={() => setModalIsOpenToTrue33(`${batch_id}`)} colSpan={2} style={{ background: '#d85b12' }}>PAY NOW</td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </>
                    ))
                ) : (
                    <p>No orders found.</p> // Fallback UI when there are no orders
                )}
            </div>
        </div>
    );
}

export default OrderHeavy_details;